// extracted by mini-css-extract-plugin
module.exports = {"recommend":"recommend-3QtfcpF3","title":"title-1-vRuZez","list_box":"list_box-2WELRqvP","no_more":"no_more-28b5d456","soft_ad":"soft_ad-3BuYFibS","hard_ad":"hard_ad-2m6XtQzO"};